module.exports = __webpack_public_path__ + "assets/img/examno.9c18ee86.png";